import { Documents } from '@/app/constants';
import useIntl from '@/infrastructure/hooks/useIntl';
import { Flex, Modal, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import clsx from 'clsx';
import { FC, useState } from 'react';

import PdfViewer from '../PdfViewer';
import styles from './index.module.css';

const Footer: FC = () => {
  const t = useIntl('common');
  const [url, setUrl] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [opened, { open, close }] = useDisclosure(false);

  const openTCLink = () => {
    setUrl(Documents.TermsAndConditionsUrl);
    setModalTitle(t('termsAndConditions'));
    open();
  };

  const openPPLink = () => {
    setUrl(Documents.PrivacyPolicyUrl);
    setModalTitle(t('privacyPolicy'));
    open();
  };

  return (
    <div className={clsx(styles['footer-wrapper'])}>
      {url && (
        <PdfViewer
          opened={opened}
          url={url}
          modalTitle={modalTitle}
          close={close}
        />
      )}
      <Flex align="center" justify="center" w="100%">
        <Text className={styles.footerText}>© 2025 Travelone</Text>
        <span className={styles.dot} />
        <UnstyledButton component="a">
          <Text
            className={styles.footerText}
            c="primary"
            fw={500}
            onClick={openTCLink}
          >
            {t('termsAndConditions')}
          </Text>
        </UnstyledButton>
        <span className={styles.dot} />
        <UnstyledButton component="a">
          <Text
            className={styles.footerText}
            c="primary"
            fw={500}
            onClick={openPPLink}
          >
            {t('privacyPolicy')}
          </Text>
        </UnstyledButton>
      </Flex>
    </div>
  );
};

export default Footer;
